import { render, staticRenderFns } from "./DeliveryPoint.vue?vue&type=template&id=566c1e8a&scoped=true"
import script from "./DeliveryPoint.js?vue&type=script&lang=js&external"
export * from "./DeliveryPoint.js?vue&type=script&lang=js&external"
import style0 from "./DeliveryPoint.vue?vue&type=style&index=0&id=566c1e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c1e8a",
  null
  
)

export default component.exports